import React, { useEffect } from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import useFxRates from '../hooks/useFxRates';
import { FormField, formInputClass } from './form';
import { formatMoney } from '../utils/money';

const CurrencyFxFields = ({
  moneda,
  monto,
  tipoCambio,
  onTipoCambioChange,
  labelClass,
  textMuted,
  inputClass,
  tc,
}) => {
  const { enabled, loading, error, preference, reload, getRateFor } = useFxRates();

  useEffect(() => {
    if (!enabled || moneda === 'ARS') return;
    if (tipoCambio && Number(tipoCambio) > 0) return;
    const rate = getRateFor(moneda);
    if (rate && onTipoCambioChange) onTipoCambioChange(rate);
  }, [enabled, moneda, tipoCambio, getRateFor, onTipoCambioChange]);

  if (!enabled || moneda === 'ARS') return null;

  const tcNum = Number(tipoCambio) || 0;
  const montoNum = Number(monto) || 0;
  const montoArs = tcNum > 0 ? Math.round(montoNum * tcNum * 100) / 100 : null;
  const prefLabel = preference === 'mep' ? 'MEP' : 'Blue';

  return (
    <div className={`rounded-xl border p-3 space-y-2 ${tc.section}`}>
      <div className="flex items-center justify-between gap-2">
        <p className={`text-xs font-medium ${tc.textPri}`}>
          Cotización {moneda} → ARS ({prefLabel})
        </p>
        <button
          type="button"
          onClick={reload}
          disabled={loading}
          className={`text-xs inline-flex items-center gap-1 text-[#1F80FF] hover:underline disabled:opacity-50`}
        >
          <FiRefreshCw className={`w-3.5 h-3.5 ${loading ? 'animate-spin' : ''}`} />
          Actualizar
        </button>
      </div>

      {error && <p className="text-xs text-red-500">{error}</p>}

      <FormField
        label="Tipo de cambio"
        hint="Podés ajustarlo si cerraste la operación a otro valor."
        labelClass={labelClass}
        textMuted={textMuted}
      >
        <input
          type="number"
          min="0"
          step="0.01"
          value={tipoCambio ?? ''}
          onChange={(e) => onTipoCambioChange?.(e.target.value)}
          className={formInputClass(tc.inputClass)}
          placeholder={`Cotización ${prefLabel}`}
        />
      </FormField>

      {montoArs != null && (
        <p className={`text-sm font-semibold ${tc.textPri}`}>
          Equivalente: {formatMoney(montoArs, 'ARS')}
        </p>
      )}
    </div>
  );
};

export default CurrencyFxFields;
